import React, { useEffect, useRef, useState } from 'react';
import Pesquisar from './Pesquisar';
import { Button, Card, notification, Spin } from 'antd';
import './TelaVendas.css'; // Assumindo que os estilos foram movidos para um arquivo CSS
import ModalItemSelecionado from './ModalItemSelecionado';
import FinalizarVenda from './FinalizarVenda';
import Leitor from './Leitor';
import TesteQr from './LeitorQRCode';
import LeitorQRCode from './LeitorQRCode';
import axios from 'axios';
import BuscarOrcamentos from './Orcamentos/BuscarOrcamentos';
import BuscarDelivery from './BuscarDelivery';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useConfigQuery } from '../../../queries/useConfig';
import axiosInstance from '../../../axiosInterceptor';
import BuscarVendas from './Operacoes/BuscarVendas';
import BuscarPedidosMkt from './Operacoes/BuscarPedidosMkt';
import { api } from '../../../config/api';
import CadastroFiscal from './Operacoes/CadastroFiscal';
import { formatarQuantidade } from '../../../utils/formatters';
import ControleDeCaixa from './ControleDeCaixa';

const TelaVendas = ({ sessaoCaixa, produtos, setProdutos, pagamentoConcluido, setPagamentoConcluido, pagamentos, setPagamentos, consumidorIdentificado, setConsumidorIdentificado, consumidor, setConsumidor, pagItem, setPagItem, setSessaoCaixa, handleCloseModal, setTelaControleDeCaixa }) => {
  const { data: config, error } = useConfigQuery();
  const [idPedidoMkt, setIdPedidoMkt] = useState("");
  const [possuiPagamento, setPossuiPagamento] = useState(null);
  const [terminal, setTerminal] = useState(1);

  const [totalProdutos, setTotalProdutos] = useState(0);
  const [quantidadeProdutos, setQuantidadeProdutos] = useState(0);

  const [totalServicos, setTotalServicos] = useState(0);
  const [quantidadeServicos, setQuantidadeServicos] = useState(0);

  const [vendaPuxada, setVendaPuxada] = useState(false);
  const [isPesquisar, setIsPesquisar] = useState(false);
  const [isFinalizarVenda, setIsFinalizarVenda] = useState(false);
  const [isBuscarOrcamento, setIsBuscarOrcamento] = useState(false);
  const [isBuscarVenda, setIsBuscarVenda] = useState(false);
  const [isBuscarPedidoMkt, setIsBuscarPedidoMkt] = useState(false);
  const [isControleCaixaVisible, setIsControleCaixaVisible] = useState(false);

  const [isBuscarDelivery, setIsBuscarDelivery] = useState(false);
  const [acresDescFreteConcluido, setAcresDescFreteConcluido] = useState(false);
  const [quantidadeDeItens, setQuantidadeDeItens] = useState(0);
  const [precoTotal, setPrecoTotal] = useState(0);
  const [totalSemFrete, setTotalSemFrete] = useState(0);
  const [totalDescontos, setTotalDescontos] = useState(0);
  const [totalAcrescimos, setTotalAcrescimos] = useState(0);
  const [subTotal, setSubtotal] = useState(0);
  const accessToken = window.localStorage.getItem("accessToken");
  const idUser = window.localStorage.getItem("idUser");
  const operador = window.localStorage.getItem("operador");
  const [isLoading, setIsLoading] = useState(false);
  const [nomeCupom, setNomeCupom] = useState('');
  const [documentoCupom, setDocumentoCupom] = useState('');
  const [numeroEvento, setnumeroEvento] = useState('');
  const [isModalVisibleBuscarOrcamento, setIsModalVisibleBuscarOrcamento] =
    useState(false);
  const [selectedProduto, setSelectedProduto] = useState(null);
  const [isModalVisibleItem, setModalVisibleItem] = useState(false);
  const [isLerCodigo, setIsLerCodigo] = useState(false);
  const [idOrcamento, setIdOrcamento] = useState('');
  const [travarAcrescimoDescFrete, setTravarAcrescimoDescFrete] = useState(false);

  const [cardAberto, setCardAberto] = useState('');
  const [consumidorIntegrado, setConsumidorIntegrado] = useState(null);
  const [tokenPedidoTechsapp, setTokenPedidoTechsapp] = useState(null);
  const [restauranteId, setRestauranteId] = useState('');
  const [formasDePagamento, setFormasDePagamento] = useState([]);
  const [idVendedorOrcamento, setIdVendedorOrcamento] = useState(null);
  const [mostrarCobranca, setMostrarCobranca] = useState(false);

  const [mensagemTela, setMensagemTela] = useState('');

  const [parametros, setParametros] = useState({
    infCpl: ''
  });
  const [fatura, setFatura] = useState(
    parametros?.cobr || {
      vLiq: precoTotal,
      vDesc: 0,
      vOrig: precoTotal,
      nFat: '001',
    }
  );
  const [infCpl, setInfCpl] = useState(parametros?.infCpl || '');

  useEffect(() => {
    if (accessToken && idUser) {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };
      axios
        .get(`${api.techfood}/v1/restaurantes/usuario/${idUser}`, options)
        .then(response => {
          setRestauranteId(response.data.id);
        })
        .catch(error => console.error('Erro ao buscar restaurante:', error));
    }
  }, [idUser, accessToken]);

  useEffect(() => {
    if (restauranteId) {
      axios
        .get(
          `${api.techspdv}/v1/restaurantes/${restauranteId}/formas-pagamento`,
          { headers: { Authorization: `Bearer ${accessToken}` } }
        )
        .then((response) => {
          const options = response.data._embedded.formasPagamento.map((forma) => ({
            label: forma.descricao,
            value: forma.codigo,
          }));
          setFormasDePagamento(options);
        });
    }
  }, [restauranteId]);

  const limparPagamento = () => {
    setPagamentoConcluido(false);
    setPagamentos([]);
    setPagItem([]);

    // limpa cobrança
    setMostrarCobranca(false);

    setFatura({
      vLiq: precoTotal,
      vDesc: 0,
      vOrig: precoTotal,
      nFat: '001',
    });

    setParametros(prev => ({
      ...prev,
      cobr: null,
    }));
  };

  const limparParametros = () => {

    setMostrarCobranca(false);

    setFatura({
      vLiq: precoTotal,
      vDesc: 0,
      vOrig: precoTotal,
      nFat: '001',
    });

    setParametros({
      infCpl: '',
      cobr: null,
    });
  };

  const [acresDescFrete, setAcresDescFrete] = useState({
    acresTotal: '0',
    descTotal: '0',
    frete: '0',
  });


  const [cpfIntegracao, setCpfIntegracao] = useState(null);




  const [recalcular, setRecalcular] = useState(false);
  const inputRef = useRef(null);
  const [mensagem, setMensagem] = useState('');

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const buscarProdutoPorCodigoBarras = async (codigoBarras) => {
    try {
      const options = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
      };

      let response = {};
      let codigoDeBalanca = false;
      if (codigoBarras !== '') {
        if (codigoBarras.startsWith("2")) {
          console.log("O código de barras começa com 2");
          codigoDeBalanca = true;

        }

        const codigoParaBusca = extrairCodigoParaBusca(codigoBarras);

        setMensagem(`🔍 Procurando o código de barras: ${codigoBarras}`);


        let startEan2 = Number(config?.terminalComercial?.startEan2);
        let endEan2 = Number(config?.terminalComercial?.endEan2);

        if (
          !Number.isInteger(startEan2) ||
          !Number.isInteger(endEan2) ||
          startEan2 < 1 ||
          startEan2 > 6 ||
          endEan2 < 1 ||
          endEan2 > 6 ||
          startEan2 > endEan2
        ) {
          startEan2 = 1;
          endEan2 = 6;
        }

        response = await axios.get(
          `${api.techspdv}/v1/restaurantes/${restauranteId}/produtos/buscarporeanCodigoBalanca/${codigoParaBusca}/${startEan2}/${endEan2}`,
          options
        );

        console.log(response.data);
        if (response.data && response.status == 200) {
          if (codigoDeBalanca) {
            console.log(response.data.quantidade);
            console.log(response.data.valorAferido);
            console.log(response.data.preco);

            const { valorAferido, preco } = response.data;

            if (
              typeof valorAferido === 'number' &&
              typeof preco === 'number' &&
              preco !== 0
            ) {
              response.data.quantidade = (valorAferido / preco).toFixed(3);
            } else {
              response.data.quantidade = "0.000";
            }


            tratarProdutoBuscadoPorCodigoDeBalanca(response.data);

          } else {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
          }
          setMensagem(``);
        } else {

          response = await axios.get(
            `${api.techspdv}/v1/restaurantes/${restauranteId}/produtos/buscarporcod/${codigoParaBusca}`,
            options
          );

          if (response.data && response.status == 200) {
            if (codigoBarras.includes('*') || codigoBarras.includes('$')) {
              tratarProdutoQuantidadeValor(response.data, codigoBarras);
            } else {
              tratarProdutoBuscadoPorEan(response.data);
            }
            setMensagem(``);
          }

          if (response.status != 200) {
            setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
          }


        }

      }
    } catch (error) {
      console.error('Erro ao buscar produto por EAN:', error);
      if (error.status == 404) {
        setMensagem(`❌ Código de barras não encontrado: ${codigoBarras}`);
      }

    }

  };
  const formatarDataHora = (data) => {
    if (!data) return '';

    const date = new Date(data);

    return date.toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };
  const mostrarCertificado =
    Array.isArray(config?.certificado?.Documentos) &&
    config.certificado.Documentos.length > 0 &&
    config.certificado.Documentos[0]?.CertDiasValido <= 30;

  const CardResumoVendas = ({
    mensagemCertificado,
    mostrarCertificado,
    onRenovarCertificado,
  }) => (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        width: '100%',
        minHeight: '64px',
        padding: '10px 14px',
        backgroundColor: '#ffffff',
        border: '1px solid #e8e8e8',
        borderRadius: '12px',
        boxShadow: '0 3px 12px rgba(0, 0, 0, 0.035)',
        boxSizing: 'border-box',
      }}
    >
      <div
        style={{
          width: '46px',
          height: '46px',
          minWidth: '46px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#f0ecff',
          fontSize: '23px',
        }}
      >
        🖥️
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          flex: 1,
          minWidth: 0,
        }}
      >
        <strong
          style={{
            color: '#111',
            fontSize: '24px',
            lineHeight: 1.2,
          }}
        >
          VENDAS
        </strong>

        {mostrarCertificado && (
          <Button
            danger
            size="small"
            onClick={onRenovarCertificado}
            style={{
              width: 'fit-content',
              maxWidth: '100%',
              marginTop: '6px',
              fontSize: '12px',
              whiteSpace: 'normal',
              height: 'auto',
              lineHeight: 1.3,
              padding: '4px 10px',
              backgroundColor: 'red',
              color: '#fff'
            }}
          >
            {mensagemCertificado}
          </Button>
        )}
      </div>
    </div>
  );
  const CardResumo = ({
    icone,
    titulo,
    valor,
    descricao,
    cor = '#1677ff',
    fundoIcone = '#eaf3ff',
    destaque = false,
    onClick,
  }) => (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        backgroundColor: '#ffffff',
        border: destaque ? `1px solid ${cor}` : '1px solid #e8e8e8',
        borderRadius: '12px',
        padding: '10px 14px',
        minHeight: '64px',
        boxShadow: destaque
          ? `0 4px 14px ${cor}20`
          : '0 3px 12px rgba(0, 0, 0, 0.035)',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      <div
        style={{
          width: '46px',
          height: '46px',
          minWidth: '46px',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: fundoIcone,
          fontSize: '23px',
        }}
      >
        {icone}
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
        }}
      >
        <span
          style={{
            color: '#777',
            fontSize: '13px',
            marginBottom: '3px',
          }}
        >
          {titulo}
        </span>

        <strong
          style={{
            color: destaque ? cor : '#111',
            fontSize: destaque ? '22px' : '18px',
            lineHeight: 1.2,
          }}
        >
          {valor}
        </strong>

        {descricao && (
          <span
            style={{
              color: '#999',
              fontSize: '12px',
              marginTop: '3px',
            }}
          >
            {descricao}
          </span>
        )}
      </div>
    </div>
  );

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      const valor = e.target.value.trim();
      if (valor) {
        buscarProdutoPorCodigoBarras(valor);
        e.target.value = ''; // limpa o campo
        inputRef.current.focus(); // volta o foco
      }
    }
  };

  const handlePesquisarClick = () => {
    setIsPesquisar(true); // Mostrar a tela de pesquisa
  };

  const handleVoltarClick = () => {
    setIsPesquisar(false);
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const focarCodigoDeBarras = () => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 100);
  };

  const handleVoltarBuscarDeliveryClick = () => {
    setIsBuscarDelivery(false); // Voltar para a tela de vendas
  };

  /* const trataProdutos = produto => {
     setProdutos([...produtos, produto]);
 
   };*/
  function temPrecoZeradoOuNulo(produtos) {
    return produtos.some(produto => produto.preco === 0 || produto.preco === null);
  }

  /* const trataProdutos = (entrada) => {
     console.log(entrada);
     const novosProdutos = Array.isArray(entrada) ? entrada : [entrada];
     setProdutos((produtosAtuais) => [...produtosAtuais, ...novosProdutos]);
     setTimeout(() => {
       inputRef.current?.focus();
     }, 100); // pequeno delay para garantir que o DOM já está pronto
   };*/

  const novoUid = () => `${Date.now()}_${Math.random().toString(16).slice(2)}`;

  const trataProdutos = (entrada) => {
    console.log(entrada);
    const arr = Array.isArray(entrada) ? entrada : [entrada];

    const novosProdutos = arr.map(p => ({
      ...p,                 // clona
      _uid: novoUid(),      // id único por linha
    }));

    setProdutos(prev => [...prev, ...novosProdutos]);

    setTimeout(() => inputRef.current?.focus(), 100);
  };



  const tratarProdutoBuscadoPorEan = item => {
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    limparPagamento();
  };

  const toNumber = (v) => {
    if (v == null) return NaN;
    const s = String(v).trim().replace(',', '.').replace(/[^\d.]/g, '');
    return Number(s);
  };

  const extrairCodigoParaBusca = (codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    if (cb.includes('$')) {
      const [, codigo] = cb.split('$');   // pega depois do $
      return String(codigo || '').trim();
    }

    if (cb.includes('*')) {
      const [, codigo] = cb.split('*');   // pega depois do *
      return String(codigo || '').trim();
    }

    return cb;
  };

  const tratarProdutoQuantidadeValor = (item, codigoBarras) => {
    const cb = String(codigoBarras || '').trim();

    // defaults
    item.quantidade = 1;
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;

    // "*" => 40*12  => quantidade=40, preco = preco*40
    if (cb.includes('*')) {
      const [qStr] = cb.split('*');
      const q = toNumber(qStr);

      if (Number.isFinite(q) && q > 0) {
        item.quantidade = q;
      }

      // "$" => 40$12  => 40 é valor total, 12 é só o código; qtd = total / precoUnit
    } else if (cb.includes('$')) {
      const [totalStr] = cb.split('$'); // ignora o "12" (código)
      const total = toNumber(totalStr);

      const precoUnit = toNumber(item.preco); // preço unitário do produto já buscado
      if (Number.isFinite(total) && total > 0 && Number.isFinite(precoUnit) && precoUnit > 0) {
        item.quantidade = total / precoUnit;

        // se quiser limitar casas (ex.: 3) para não ficar infinito:
        // item.quantidade = Number((total / precoUnit).toFixed(3));
      }
    }

    trataProdutos(item);
    limparPagamento();
  };


  const tratarProdutoBuscadoPorCodigoDeBalanca = item => {
    item.acrescimo = 0;
    item.desconto = 0;
    item.valorAcrescimo = 0;
    item.valorDesconto = 0;
    item.frete = 0;
    trataProdutos(item);
    limparPagamento();
  };



  const getDataAtual = () => {
    const dataAtual = new Date();
    const dia = String(dataAtual.getDate()).padStart(2, '0');
    const mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    const ano = dataAtual.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };

  /*const CalcularTotais = () => {
    var quantidadeDeItensAux = 0;
    var precoTotalAux = 0;
    var totalSemFreteAux = 0;
    var subTotalAux = 0;
    var totalDescontosAux = 0;
    var totalAcrescimosAux = 0;

    produtos.map(produto => {
      console.log(produto);
      quantidadeDeItensAux = parseFloat(quantidadeDeItensAux) + parseFloat(produto.quantidade);



      subTotalAux = subTotalAux + produto.preco * produto.quantidade;
      totalSemFreteAux =
        totalSemFreteAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo);

      precoTotalAux =
        precoTotalAux +
        produto.preco * produto.quantidade -
        parseFloat(produto.valorDesconto) +
        parseFloat(produto.valorAcrescimo) +
        parseFloat(produto.frete ? produto.frete : 0);

      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log('precoTotalAux');
      console.log(precoTotalAux);

      totalDescontosAux += parseFloat(produto.valorDesconto);
      totalAcrescimosAux += parseFloat(produto.valorAcrescimo);
    });

    setQuantidadeDeItens(quantidadeDeItensAux);
    setPrecoTotal(precoTotalAux);
    setTotalSemFrete(totalSemFreteAux);
    setSubtotal(subTotalAux);
    setTotalDescontos(totalDescontosAux);
    setTotalAcrescimos(totalAcrescimosAux);
  };*/

  const arredondar2 = (valor) =>
    Math.round((Number(valor) + Number.EPSILON) * 100) / 100;


  const CalcularTotais = () => {


    console.log(produtos);

    let quantidadeDeItensAux = 0;
    let precoTotalAux = 0;
    let totalSemFreteAux = 0;
    let subTotalAux = 0;
    let totalDescontosAux = 0;
    let totalAcrescimosAux = 0;

    // Novos totais separados
    let totalProdutosAux = 0;
    let quantidadeProdutosAux = 0;

    let totalServicosAux = 0;
    let quantidadeServicosAux = 0;

    produtos.forEach(produto => {
      console.log(produto);

      const quantidade = Number(produto.quantidade || 0);
      const preco = Number(produto.preco || 0);
      const valorDesconto = Number(produto.valorDesconto || 0);
      const valorAcrescimo = Number(produto.valorAcrescimo || 0);
      const frete = Number(produto.frete || 0);

      /*
       * Mantém exatamente a mesma lógica usada atualmente
       * no total sem frete.
       */
      const totalItemSemFrete = arredondar2(
        preco * quantidade - valorDesconto + valorAcrescimo
      );

      quantidadeDeItensAux += quantidade;

      subTotalAux += arredondar2(preco * quantidade);

      console.log(totalSemFreteAux);
      console.log(totalItemSemFrete);

      totalSemFreteAux += totalItemSemFrete;
      console.log(totalSemFreteAux);
      precoTotalAux +=
        totalItemSemFrete +
        frete;

      totalDescontosAux += valorDesconto;
      totalAcrescimosAux += valorAcrescimo;

      /*
       * ntipoItem 5 = serviço.
       * Todos os demais tipos continuam sendo tratados como produto.
       */
      const ehServico = Number(produto.ntipoItem) === 5;

      if (ehServico) {
        quantidadeServicosAux += quantidade;
        totalServicosAux += totalItemSemFrete;
      } else {
        quantidadeProdutosAux += quantidade;
        totalProdutosAux += totalItemSemFrete;
      }
    });

    // Totais que já existiam
    setQuantidadeDeItens(quantidadeDeItensAux);
    setPrecoTotal(precoTotalAux);
    setTotalSemFrete(totalSemFreteAux);
    setSubtotal(subTotalAux);
    setTotalDescontos(totalDescontosAux);
    setTotalAcrescimos(totalAcrescimosAux);

    // Novos totais separados
    setQuantidadeProdutos(quantidadeProdutosAux);
    setTotalProdutos(Number(totalProdutosAux.toFixed(2)));

    setQuantidadeServicos(quantidadeServicosAux);
    setTotalServicos(Number(totalServicosAux.toFixed(2)));
  };

  const openModalItem = produto => {
    setSelectedProduto(produto);
    setModalVisibleItem(!isModalVisibleItem);
  };
  useEffect(() => {
    CalcularTotais();
  }, [produtos, recalcular]);

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', backgroundColor: '#f9f9f9' }}>
      {/*<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        {(Array.isArray(config?.certificado?.Documentos) &&
          config.certificado.Documentos.length > 0 &&
          config.certificado.Documentos[0]?.CertDiasValido <= 90)
          ?
          <Button
            type="primary"
            onClick={async () => {
              console.log(config);
              const numero = "5511963697271";
              let mensagem = '';
              if (Array.isArray(config?.certificado?.Documentos) &&
                config.certificado.Documentos[0]?.CertDiasValido != null) {
                mensagem = "Quero renovar meu certificado digital para o TechsPDV";
              } else {
                mensagem = 'Certificado Digital Não Encontrado!';
              }

              //  const url = `https://wa.me/${numero}?text=${encodeURIComponent(mensagem)}`;

              const url = `https://seucertificadodigital.com/loja/?p=u49-tech-union`;

              window.open(url, "_blank");

              const options = {
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + accessToken,
                },
              };

              axiosInstance.get(
                `${api.technfe}/v1/enviarEmailRenovarCertificado/${config?.restaurante.nome}`,
                options
              );

            }}
            style={{ backgroundColor: "red", borderColor: "red", fontSize: '15px' }}
          >
            <span style={{ color: "white" }}>
              {config?.mensagemCertificado}
            </span>
          </Button>
          : ''}

      </div>
      /*}


      {/* Se isPesquisar for verdadeiro, exibe o conteúdo de pesquisa */}
      {isBuscarPedidoMkt ? (
        <BuscarPedidosMkt
          closeModal={() => {
            setIsBuscarPedidoMkt(false);
            focarCodigoDeBarras();
          }}
          tratarProdutosOrcamento={async (orcamento) => {
            try {
              setTimeout(() => {
                setIsLoading(true);
              }, 2000);

              setVendaPuxada(true);

              console.log(orcamento?.id);

              const cnpj = encodeURIComponent(config?.restaurante?.cnpj ?? "");

              const pedidoMkt = await axios.get(

                `https://apimarket.pedtech.com.br/v1/${config.restaurante.tipoMkt == '2' ? 'oruc' : 'mkt'}/pedidos/${orcamento?.id}/${cnpj}`,
                {
                  headers: {
                    token: config?.tokenMarketplace,
                  },
                  // signal: controller.signal,
                }
              );
              const documento = pedidoMkt?.data?.billing?.documentId?.replace(/[^0-9]/g, "");
              console.log(pedidoMkt?.data?.billing?.documentId?.replace(/[^0-9]/g, ""));
              setIdPedidoMkt(orcamento?.id || "");

              console.log("Pedidos MKT:", pedidoMkt.data);

              if (pedidoMkt.data.paymentMethods?.length > 0) {
                const options = {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                  },
                };

                const pagamentosAux = await Promise.all(
                  pedidoMkt.data.paymentMethods.map(async (pagamento) => {
                    try {
                      // ✅ se o endpoint é por-cardbrand, use o cardbrand
                      const method = encodeURIComponent(pagamento.method ?? "0");
                      const cardbrand = encodeURIComponent(pagamento.cardBrand ?? "0");
                      const meiosDePagamentoMkt = await axiosInstance.get(
                        `${api.techspdv}/v1/meios-pagamento-marketplace/por-method/${method}/por-cardbrand/${cardbrand}`,
                        options
                      );

                      if (meiosDePagamentoMkt.data?.length > 0) {
                        const m = meiosDePagamentoMkt.data[0];
                        return {
                          tipo: m.codigo,
                          tipoNome: m.descricao,
                          valor: pagamento.value,
                        };
                      }

                      return { tipo: "99", tipoNome: "Outros", valor: pagamento.value };
                    } catch (e) {
                      return { tipo: "99", tipoNome: "Outros", valor: pagamento.value };
                    }
                  })
                );

                setPagamentos(pagamentosAux);

                const pagItemAux = pagamentosAux.map((p) => ({
                  tPag: p.tipo,
                  vPag: Number(p.valor || 0).toFixed(2),
                  xPag: p.tipoNome,
                }));

                setPagItem(pagItemAux);
                setPagamentoConcluido(true);
              }


              console.log('orcamento');

              // Identificação do consumidor: executa UMA vez por pedido, antes dos itens.
              function validarDocumento(documento) {
                console.log(documento);
                // Remover caracteres não numéricos
                documento = documento.replace(/[^\d]+/g, '');

                // Verificar se o documento é um CPF
                if (documento.length === 11) {
                  let cpf = documento;
                  let add = 0;
                  for (let i = 0; i < 9; i++) {
                    add += parseInt(cpf.charAt(i)) * (10 - i);
                  }
                  let rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(9))) return false;

                  add = 0;
                  for (let i = 0; i < 10; i++) {
                    add += parseInt(cpf.charAt(i)) * (11 - i);
                  }
                  rev = 11 - (add % 11);
                  if (rev === 10 || rev === 11) rev = 0;
                  if (rev !== parseInt(cpf.charAt(10))) return false;

                  return true;
                }

                // Verificar se o documento é um CNPJ
                else if (documento.length === 14) {
                  let cnpj = documento;
                  let tamanho = cnpj.length - 2;
                  let numeros = cnpj.substring(0, tamanho);
                  let digitos = cnpj.substring(tamanho);
                  let soma = 0;
                  let pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(0))) return false;

                  tamanho = tamanho + 1;
                  numeros = cnpj.substring(0, tamanho);
                  soma = 0;
                  pos = tamanho - 7;
                  for (let i = tamanho; i >= 1; i--) {
                    soma += numeros.charAt(tamanho - i) * pos--;
                    if (pos < 2) pos = 9;
                  }
                  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                  if (resultado !== parseInt(digitos.charAt(1))) return false;

                  return true;
                }

                // Se não for nem CPF nem CNPJ, retorna false
                else {
                  return false;
                }
              }

              if (documento && validarDocumento(documento) && accessToken) {
                const optionsCliente = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                const urlCliente = `${api.techspdv}/v1/clientes/loja/${config.idLoja}/cpfcnpj/${documento}`;
                let clienteEncontrado = null;
                let clienteNaoExiste = false;

                try {
                  const consulta = await axios.get(urlCliente, optionsCliente);
                  if (consulta.data) {
                    clienteEncontrado = consulta.data;
                  } else {
                    // Endpoint que retorna 200 sem conteúdo para cliente inexistente.
                    clienteNaoExiste = true;
                  }
                } catch (erroConsulta) {
                  if (erroConsulta.response?.status === 404) {
                    clienteNaoExiste = true;
                  } else {
                    // Erro de rede/servidor NÃO significa que o cliente não exista.
                    console.error('Erro ao consultar cliente do marketplace:', erroConsulta);
                    notification.error({
                      message: 'Erro ao consultar cliente',
                      description: 'Não foi possível verificar o cadastro do cliente.',
                    });
                  }
                }

                if (clienteEncontrado) {
                  const shipping = pedidoMkt.data.shipping || {};
                  const billing = pedidoMkt.data.billing || {};
                  const clienteAtualizado = {
                    ...clienteEncontrado,
                    nomeCompleto: shipping.recipientName ?? clienteEncontrado.nomeCompleto,
                    telefone: shipping.phone ?? clienteEncontrado.telefone,
                    documentoCpfCnpj: documento,
                    email: billing.email ?? clienteEncontrado.email,
                    endereco: {
                      ...(clienteEncontrado.endereco || {}),
                      numero: shipping.streetNumber ?? clienteEncontrado.endereco?.numero,
                      logradouro: shipping.street ?? clienteEncontrado.endereco?.logradouro,
                      cep: shipping.zipCode ?? clienteEncontrado.endereco?.cep,
                      bairro: shipping.district ?? clienteEncontrado.endereco?.bairro,
                      complemento: shipping.streetComplement ?? clienteEncontrado.endereco?.complemento,
                      cidade: {
                        ...(clienteEncontrado.endereco?.cidade || {}),
                        estado: shipping.state ?? clienteEncontrado.endereco?.cidade?.estado,
                      },
                    },
                  };
                  setConsumidor(clienteAtualizado);
                  setConsumidorIdentificado(true);
                  notification.success({ message: 'Sucesso', description: 'Cliente encontrado!!' });
                } else if (clienteNaoExiste) {
                  try {
                    const shipping = pedidoMkt.data.shipping || {};
                    const billing = pedidoMkt.data.billing || {};
                    const cep = String(shipping.zipCode || '').replace(/\D/g, '');
                    let cidadeCorrespondente = null;

                    if (cep) {
                      const respostaCep = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
                      const dataCep = respostaCep.data;
                      if (!dataCep?.erro && String(dataCep?.ibge || '').length === 7) {
                        const estadoMkt = String(dataCep.ibge).substring(0, 2);
                        const respostaCidades = await axios.get(
                          `${api.techspdv}/v1/cidades/listarPorEstadoCuf/${estadoMkt}`,
                          optionsCliente
                        );
                        const cidades = respostaCidades.data?._embedded?.cidades || [];
                        cidadeCorrespondente = cidades.find(c => String(c.ibge) === String(dataCep.ibge));
                      }
                    }

                    const consumidorAux = {
                      ativo: true,
                      nomeCompleto: shipping.recipientName,
                      endereco: {
                        numero: shipping.streetNumber,
                        logradouro: shipping.street,
                        cep: shipping.zipCode,
                        bairro: shipping.district,
                        complemento: shipping.streetComplement || '',
                        cidade: { id: cidadeCorrespondente?.id || '' },
                      },
                      telefone: shipping.phone || billing.phone,
                      documentoCpfCnpj: documento,
                      email: '',
                      documentoRgIE: '',
                    };

                    const cadastro = await axios.post(
                      `${api.techspdv}/v1/clientes/loja/${config.idLoja}`,
                      consumidorAux,
                      optionsCliente
                    );
                    setConsumidor(cadastro.data);
                    setConsumidorIdentificado(true);
                    notification.success({ message: 'Sucesso', description: 'Cliente cadastrado!!' });
                  } catch (erroCadastro) {
                    console.error('Erro ao cadastrar cliente do marketplace:', erroCadastro);
                    notification.error({
                      message: 'Erro no cadastro do cliente',
                      description: 'Não foi possível cadastrar o cliente do marketplace.',
                    });
                  }
                }
              }

              pedidoMkt.data.orderItems.map(async produto => {
                console.log(produto);

                try {
                  const options = {
                    headers: {
                      Accept: 'application/json',
                      'Content-Type': 'application/json',
                      Authorization: 'Bearer ' + accessToken,
                    },
                  };
                  const body = {
                    texto: `${produto.sku}`
                  }
                  const response = await axios.post(
                    `${api.techspdv}/v1/restaurantes/${config.restaurante.id}/produtos/sku?page=${0}`, body,
                    options,
                  );

                  const produtosAux = produtos;
                  console.log(response.data);

                  let produtoTechspdv = null;
                  console.log(!response?.data_embedded);

                  if (!response?.data?._embedded) {
                    // cadastrar produto
                    const categoria = await axios.get(
                      `${api.techfood}/v1/categorias/restaurante/${config?.idLoja}/todas`,
                      options
                    );

                    let cadastroFiscal = null;

                    try {
                      const ncmBusca = produto.ncm || config?.terminalComercial?.ncm || '';

                      const response = await fetch(
                        `${api.techspdv}/api/cadastro-fiscal/loja/${config?.idLoja}/ncm/${ncmBusca}`,
                        options
                      );

                      if (response.ok) {
                        cadastroFiscal = await response.json();
                        console.log("✅ Dados fiscais carregados:", cadastroFiscal);
                      }
                      else if (response.status === 404) {
                        console.warn(`NCM ${ncmBusca} não encontrado. Usando valores padrão.`);
                      }
                      else {
                        console.error(`Erro ${response.status} ao buscar dados fiscais`);
                      }

                    } catch (error) {
                      console.error("Erro na requisição de cadastro fiscal:", error);
                    }

                    // Payload fora do try
                    const payload = {
                      nome: produto.name,
                      descricao: produto.name,
                      ean: produto.ean || 'SEM GTIN',
                      ncm: produto.ncm || config?.terminalComercial?.ncm || '',
                      cest: cadastroFiscal?.cest || produto.cest || '',
                      preco: produto.price || 0,
                      sku: produto.sku || '',
                      custo: 0,
                      ntipoItem: produto.nTipoItem || '0',
                      codigo: null,
                      origem: cadastroFiscal?.origem ?? produto.origem ?? 0,
                      unidade: 'UN',
                      cfop: cadastroFiscal?.cfop || '5102',
                      cst: cadastroFiscal?.cst || '102',
                      weight: 0,
                      predBc: 0,
                      picms: cadastroFiscal?.picms || 0,

                      // ✅ Agora vai pegar corretamente "49"
                      cstPis: cadastroFiscal?.cstPis || '07',
                      cstCofins: cadastroFiscal?.cstCofins || '07',

                      cclassTrib: cadastroFiscal?.cclassTrib || '000001',
                      ibscbsCst: cadastroFiscal?.ibscbsCst || '000',
                      pibsuf: cadastroFiscal?.pibsuf || 0.1,
                      pcbs: cadastroFiscal?.pcbs || 0.9,
                      pibsMun: cadastroFiscal?.pibsMun || 0,

                      unidadeTributavel: 'UN',
                      ativo: true,
                      categoria: categoria.data?._embedded?.categoriaList?.[0]?.id
                    };


                    const response = await axios.post(
                      `${api.techfood}/v1/restaurantes/${config.idLoja}/produtos`,
                      payload,
                      options
                    );


                    produtoTechspdv = response.data;
                  } else {
                    produtoTechspdv = response.data._embedded.produtos[0];
                  }



                  if (produtoTechspdv) {

                    console.log(produtoTechspdv);
                    produtoTechspdv.preco = produto.price;
                    produtoTechspdv.quantidade = produto.quantity;
                    produtoTechspdv.acrescimo = 0;
                    produtoTechspdv.desconto = produto.discount;
                    produtoTechspdv.valorAcrescimo = 0;
                    produtoTechspdv.valorDesconto = produto.discount;
                    produtoTechspdv.frete = produto.freight ? produto.freight : "0";
                    produtoTechspdv.observacao = '';
                    produtoTechspdv.idVendedor = produto.idVendedor || '';
                    produtoTechspdv.nItemPed = '';
                    produtoTechspdv.xPed_item = '';
                    produtoTechspdv.travado = true;

                    console.log(produtoTechspdv);
                    produtosAux.push(produtoTechspdv);
                    CalcularTotais();
                  }

                  setProdutos(produtosAux);
                  let acresDescFreteAux = acresDescFrete;
                  acresDescFreteAux.frete = produto.freight;
                  setAcresDescFrete(acresDescFreteAux);

                } catch (error) {
                  setIsLoading(false);
                  console.error('Erro ao fazer a requisição:', error);
                  setVendaPuxada(false);
                }
              })





              // aqui você trata o retorno e atualiza state
              // ex: setPedidosMkt(response.data);
            } catch (err) {
              console.error(err);
              // opcional: message.error("Erro ao buscar pedidos do marketplace");
            } finally {
              setTimeout(() => {
                setIsLoading(false);
              }, 2000);
            }


          }}
        />

      ) : isBuscarOrcamento ? (
        <BuscarOrcamentos
          closeModal={() => {
            setIsBuscarOrcamento(false);
            focarCodigoDeBarras();
          }}
          tratarProdutosOrcamento={orcamento => {
            setIsLoading(true);
            setVendaPuxada(true);
            setIdVendedorOrcamento(orcamento.idVendedor);
            console.log(orcamento);

            function validarDocumento(documento) {
              // Remover caracteres não numéricos
              documento = documento.replace(/[^\d]+/g, '');

              // Verificar se o documento é um CPF
              if (documento.length === 11) {
                let cpf = documento;
                let add = 0;
                for (let i = 0; i < 9; i++) {
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(9))) return false;

                add = 0;
                for (let i = 0; i < 10; i++) {
                  add += parseInt(cpf.charAt(i)) * (11 - i);
                }
                rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(10))) return false;

                return true;
              }

              // Verificar se o documento é um CNPJ
              else if (documento.length === 14) {
                let cnpj = documento;
                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(1))) return false;

                return true;
              }

              // Se não for nem CPF nem CNPJ, retorna false
              else {
                return false;
              }
            }
            if (validarDocumento(orcamento.cpf)) {
              console.log('Cpf valido');
              if (accessToken) {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                axios
                  .get(
                    `${api.techspdv}/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                    options,
                  )
                  .then(consumidorResp => {
                    console.log(
                      `${api.techspdv}/v1/clientes/loja/${orcamento.idEmpresa}/cpfcnpj/${orcamento.cpf}`,
                    );

                    if (consumidorResp) {
                      console.log(consumidorResp.data);
                      if (consumidorResp.data) {
                        setConsumidor(consumidorResp.data);
                        setConsumidorIdentificado(true);
                      }
                    }
                  })
              }
            }

            if (produtos.length == 0) {
              const pagamentosAux = [];
              orcamento.pagamentos.map(pagamento => {

                const novoPagamento = {
                  tipo: pagamento.codigoFiscal,
                  tipoNome: pagamento.descricao,
                  valor: pagamento.valor,
                }
                pagamentosAux.push(novoPagamento);

              })
              console.log('Pagamentos');
              console.log(pagamentosAux);
              setPagamentos(pagamentosAux);
              let pagItemAux = new Array();
              pagamentosAux.map(pagamento => {
                const pagamentoFormatado = {
                  tPag: pagamento.tipo,
                  vPag: pagamento.valor.toFixed(2),
                  xPag: pagamento.tipoNome,
                };
                pagItemAux.push(pagamentoFormatado);
              });
              setPagItem(pagItemAux);

              setPagamentoConcluido(true);
            }

            console.log('orcamento');
            console.log(JSON.parse(orcamento.jsonDocFiscal).det.detItem);

            // pegue e normalize o detItem
            const detItems = JSON.parse(orcamento.jsonDocFiscal)?.det?.detItem;
            const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

            // índice por cProd (chave como string para evitar problemas de tipo)
            const detByCProd = new Map(
              detArray.map(it => [String(it?.prod?.cProd), it])
            );

            detArray.map(async item => {
              console.log(item);

              const produto = item?.prod;
              try {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                const response = await axios.get(
                  `${api.techspdv}/v1/restaurantes/${orcamento.idEmpresa
                  }/produtos/${produto.cProd}?page=${0}`,
                  options,
                );

                const produtosAux = produtos;
                if (response.data) {
                  console.log(response.data);

                  response.data.preco = produto.vUnCom;
                  response.data.quantidade = produto.qCOM;
                  response.data.acrescimo = produto.vOutro_item;
                  response.data.desconto = produto.vDesc;
                  response.data.valorAcrescimo = produto.vOutro_item;
                  response.data.valorDesconto = produto.vDesc;
                  response.data.frete = produto.vFrete ? produto.vFrete : 0;
                  response.data.observacao = item?.infADProd || '';
                  response.data.idVendedor = produto.idVendedor || '';
                  response.data.nItemPed = item?.nItemPed || '';
                  response.data.xPed_item = item?.xPed_item || '';

                  console.log(response.data);
                  produtosAux.push(response.data);
                  CalcularTotais();
                }

                setProdutos(produtosAux);

              } catch (error) {
                setIsLoading(false);
                console.error('Erro ao fazer a requisição:', error);
                setVendaPuxada(false);
              }
            })

            setIdOrcamento(orcamento.id);

            let acresDescFreteAux = acresDescFrete;
            acresDescFreteAux.frete = orcamento.valorFrete;
            setAcresDescFrete(acresDescFreteAux);
            console.log('orcamento');
            console.log('orcamento');
            console.log(orcamento);
            console.log('produtos');
            console.log(produtos);
            setIsLoading(false);

          }}
        />

      ) : isBuscarVenda ? (
        <BuscarVendas
          closeModal={() => {
            setIsBuscarVenda(false);
            focarCodigoDeBarras();
          }}
          tratarProdutosOrcamento={venda => {

            // setIdVendedorOrcamento(orcamento.idVendedor);
            console.log(venda);
            setIsLoading(true);
            setVendaPuxada(true);
            function validarDocumento(documento) {
              // Remover caracteres não numéricos
              documento = documento.replace(/[^\d]+/g, '');

              // Verificar se o documento é um CPF
              if (documento.length === 11) {
                let cpf = documento;
                let add = 0;
                for (let i = 0; i < 9; i++) {
                  add += parseInt(cpf.charAt(i)) * (10 - i);
                }
                let rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(9))) return false;

                add = 0;
                for (let i = 0; i < 10; i++) {
                  add += parseInt(cpf.charAt(i)) * (11 - i);
                }
                rev = 11 - (add % 11);
                if (rev === 10 || rev === 11) rev = 0;
                if (rev !== parseInt(cpf.charAt(10))) return false;

                return true;
              }

              // Verificar se o documento é um CNPJ
              else if (documento.length === 14) {
                let cnpj = documento;
                let tamanho = cnpj.length - 2;
                let numeros = cnpj.substring(0, tamanho);
                let digitos = cnpj.substring(tamanho);
                let soma = 0;
                let pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(0))) return false;

                tamanho = tamanho + 1;
                numeros = cnpj.substring(0, tamanho);
                soma = 0;
                pos = tamanho - 7;
                for (let i = tamanho; i >= 1; i--) {
                  soma += numeros.charAt(tamanho - i) * pos--;
                  if (pos < 2) pos = 9;
                }
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado !== parseInt(digitos.charAt(1))) return false;

                return true;
              }

              // Se não for nem CPF nem CNPJ, retorna false
              else {
                return false;
              }
            }
            if (validarDocumento(venda.cpf)) {
              console.log('Cpf valido');
              if (accessToken) {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                axios
                  .get(
                    `${api.techspdv}/v1/clientes/loja/${venda.idEmpresa}/cpfcnpj/${venda.cpf}`,
                    options,
                  )
                  .then(consumidorResp => {
                    console.log(
                      `${api.techspdv}/v1/clientes/loja/${venda.idEmpresa}/cpfcnpj/${venda.cpf}`,
                    );

                    if (consumidorResp) {
                      console.log(consumidorResp.data);
                      if (consumidorResp.data) {
                        setConsumidor(consumidorResp.data);
                        setConsumidorIdentificado(true);
                      }
                    }
                  })
              }
            }

            if (produtos.length == 0) {
              const pagamentosAux = [];
              venda.pagamentos.map(pagamento => {

                const novoPagamento = {
                  tipo: pagamento.codigoFiscal,
                  tipoNome: pagamento.descricao,
                  valor: pagamento.valor,
                }
                pagamentosAux.push(novoPagamento);

              })
              console.log('Pagamentos');
              console.log(pagamentosAux);
              setPagamentos(pagamentosAux);



              let pagItemAux = new Array();
              pagamentosAux.map(pagamento => {
                const pagamentoFormatado = {
                  tPag: pagamento.tipo,
                  vPag: pagamento.valor.toFixed(2),
                  xPag: pagamento.tipoNome,
                };
                pagItemAux.push(pagamentoFormatado);
              });
              setPagItem(pagItemAux);

              setPagamentoConcluido(true);
            }


            console.log('orcamento');
            console.log(JSON.parse(venda.jsonDocFiscal).det.detItem);
            console.log(JSON.parse(venda.jsonDocFiscal));

            // Recupera os parâmetros da nota original, quando existirem.
            let documentoFiscal = {};

            try {
              documentoFiscal = typeof venda.jsonDocFiscal === 'string'
                ? JSON.parse(venda.jsonDocFiscal || '{}')
                : (venda.jsonDocFiscal || {});
            } catch (error) {
              console.error('JSON fiscal inválido na venda consultada:', error);
            }

            const parametrosRecuperados = {};

            if (documentoFiscal?.infAdic?.infCpl != null) {
              parametrosRecuperados.infCpl = documentoFiscal.infAdic.infCpl;
              setInfCpl(documentoFiscal.infAdic.infCpl);
            }

            if (documentoFiscal?.transp != null) {
              parametrosRecuperados.transp = documentoFiscal.transp;
            }

            if (documentoFiscal?.ide?.NumeroPedido != null) {
              parametrosRecuperados.NumeroPedido = String(documentoFiscal.ide.NumeroPedido);
            }

            if (documentoFiscal?.ide?.dhEmi) {
              parametrosRecuperados.dataEmissao = documentoFiscal.ide.dhEmi;
            }

            if (documentoFiscal?.ide?.indPag != null) {
              parametrosRecuperados.indPag = String(documentoFiscal.ide.indPag);
            }

            if (documentoFiscal?.cobr?.fat != null) {

              if (documentoFiscal?.cobr) {
                const fat = documentoFiscal.cobr.fat || {};

                const duplicatas = Array.isArray(documentoFiscal.cobr.dup)
                  ? documentoFiscal.cobr.dup
                  : documentoFiscal.cobr.dup?.dup || [];

                const faturaRecuperada = {
                  ...fat,
                  dup: {
                    dup: duplicatas
                  }
                };

                parametrosRecuperados.cobr = faturaRecuperada;

                setFatura(faturaRecuperada);
                setMostrarCobranca(true);
              }

            }

            setParametros(prev => ({
              ...prev,
              ...parametrosRecuperados
            }));

            console.log('Documento fiscal recuperado:', documentoFiscal);

            // pegue e normalize o detItem
            const detItems = documentoFiscal?.det?.detItem;
            const detArray = Array.isArray(detItems) ? detItems : (detItems ? [detItems] : []);

            // índice por cProd (chave como string para evitar problemas de tipo)
            const detByCProd = new Map(
              detArray.map(it => [String(it?.prod?.cProd), it])
            );

            detArray.map(async item => {
              console.log(item);

              const produto = item?.prod;
              try {
                const options = {
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                  },
                };

                let response = await axios.get(
                  `${api.techspdv}/v1/restaurantes/${venda.idEmpresa
                  }/produtos/${produto.cProd}?page=${0}`,
                  options,
                );

                const produtosAux = produtos;
                if (response.data) {
                  console.log(response.data);

                  response.data.preco = produto.vUnCom;
                  response.data.quantidade = produto.qCOM;
                  response.data.acrescimo = produto.vOutro_item;
                  response.data.desconto = produto.vDesc;
                  response.data.valorAcrescimo = produto.vOutro_item;
                  response.data.valorDesconto = produto.vDesc;
                  response.data.frete = produto.vFrete ? produto.vFrete : 0;
                  response.data.observacao = item?.infADProd || '';
                  response.data.idVendedor = produto.idVendedor || '';

                  response.data.nItemPed = item?.prod.nItemPed || '';
                  response.data.xPed_item = item?.prod.xPed_item || '';

                  console.log(response.data);
                  produtosAux.push(response.data);
                  CalcularTotais();
                }

                setProdutos(produtosAux);
              } catch (error) {
                setIsLoading(false);
                setVendaPuxada(false);
                console.error('Erro ao fazer a requisição:', error);
              }
            })



            /* orcamento.itens.map(async prod => {
               try {
                 const options = {
                   headers: {
                     Accept: 'application/json',
                     'Content-Type': 'application/json',
                     Authorization: 'Bearer ' + accessToken,
                   },
                 };
                 console.log(
                   `${api.techspdv}/v1/restaurantes/${orcamento.idEmpresa
                   }/produtos/${prod.idReferencialProduto}?page=${0}`,
                 );
                 const response = await axios.get(
                   `${api.techspdv}/v1/restaurantes/${orcamento.idEmpresa
                   }/produtos/${prod.idReferencialProduto}?page=${0}`,
                   options,
                 );
   
                 const produtosAux = produtos;
                 if (response.data) {
                   console.log(response.data);
                   console.log(prod);
                   response.data.preco = prod.valorUnitario;
                   response.data.quantidade = prod.quantidade;
                   response.data.acrescimo = prod.valorTotalAcrescimo;
                   response.data.desconto = prod.valorTotalDesconto;
                   response.data.valorAcrescimo = prod.valorTotalAcrescimo;
                   response.data.valorDesconto = prod.valorTotalDesconto;
                   response.data.frete = prod.vfrete ? prod.vfrete : 0;
                   response.data.observacao = detByCProd.get(prod.idReferencialProduto).prod.observacao;
                   console.log(response.data);
                   produtosAux.push(response.data);
                   CalcularTotais();
                 }
   
                 setProdutos(produtosAux);
               } catch (error) {
                 setIsLoading(false);
                 console.error('Erro ao fazer a requisição:', error);
               }
             });*/
            //   setIdOrcamento(venda.id);

            let acresDescFreteAux = acresDescFrete;
            acresDescFreteAux.frete = venda.valorFrete;
            setAcresDescFrete(acresDescFreteAux);
            console.log('venda');
            console.log(venda);
            console.log('produtos');
            console.log(produtos);
            setIsLoading(false);
          }}
        />

      ) : isBuscarDelivery ? (
        <BuscarDelivery
          onItemPress={trataProdutos}
          setPagamentoConcluido={setPagamentoConcluido}
          setPagamentos={setPagamentos}
          closeModal={() => { handleVoltarBuscarDeliveryClick(); focarCodigoDeBarras(); }}
          setAcresDescFrete={setAcresDescFrete}
          acresDescFrete={acresDescFrete}
          setTravarAcrescimoDescFrete={setTravarAcrescimoDescFrete}
          setDocumentoCupom={setDocumentoCupom}
          setNomeCupom={setNomeCupom}
          consumidorIntegrado={consumidorIntegrado}
          setConsumidorIntegrado={setConsumidorIntegrado}
          consumidor={consumidor}
          setConsumidor={setConsumidor}
          setTokenPedidoTechsapp={setTokenPedidoTechsapp}
          setVendaPuxada={setVendaPuxada}
          setMensagemTela={setMensagemTela}

        ></BuscarDelivery>
      ) : isPesquisar ? (
        <Pesquisar
          onItemPress={trataProdutos}
          setPagamentoConcluido={setPagamentoConcluido}
          setPagamentos={setPagamentos}
          closeModal={handleVoltarClick}
          validarEstoque={true}
          disabled={idPedidoMkt}
        ></Pesquisar>
      ) : isLerCodigo ? (
        /*  <Leitor
        closeModal={() => {
          setIsLerCodigo(false);
        }}
        onItemPress={trataProdutos}
        setPagamentoConcluido={setPagamentoConcluido}
        setPagamentos={setPagamentos}>
      </Leitor>*/
        <LeitorQRCode />
      ) :
        isFinalizarVenda ? (<FinalizarVenda
          closeModal={() => { setIsFinalizarVenda(false) }}
          onItemPress={trataProdutos}
          setConsumidorIdentificado={setConsumidorIdentificado}
          consumidorIdentificado={consumidorIdentificado}
          nomeCupom={nomeCupom}
          documentoCupom={documentoCupom}
          setNomeCupom={setNomeCupom}
          setDocumentoCupom={setDocumentoCupom}
          consumidor={consumidor}
          setConsumidor={setConsumidor}
          precoTotal={precoTotal}
          pagamentoConcluido={pagamentoConcluido}
          setPagamentoConcluido={setPagamentoConcluido}
          pagamentos={pagamentos}
          setPagamentos={setPagamentos}
          produtos={produtos}
          setProdutos={setProdutos}
          subTotal={subTotal}
          CalcularTotais={CalcularTotais}
          acresDescFrete={acresDescFrete}
          setAcresDescFrete={setAcresDescFrete}
          totalDescontos={totalDescontos}
          totalAcrescimos={totalAcrescimos}
          acresDescFreteConcluido={acresDescFreteConcluido}
          setAcresDescFreteConcluido={setAcresDescFreteConcluido}
          setPagItem={setPagItem}
          pagItem={pagItem}
          travarAcrescimoDescFrete={travarAcrescimoDescFrete}
          cpfIntegracao={cpfIntegracao}
          tokenPedidoTechsapp={tokenPedidoTechsapp}
          setTokenPedidoTechsapp={setTokenPedidoTechsapp}
          formasDePagamento={formasDePagamento}
          idVendedorOrcamento={idVendedorOrcamento}
          idOrcamento={idOrcamento}
          setVendaPuxada={setVendaPuxada}
          setIdPedidoMkt={setIdPedidoMkt}
          idPedidoMkt={idPedidoMkt}
          focarCodigoDeBarras={focarCodigoDeBarras}
          setMensagemTela={setMensagemTela}
          sessaoCaixa={sessaoCaixa}
          parametros={parametros}
          setParametros={setParametros}
          fatura={fatura}
          setFatura={setFatura}
          infCpl={infCpl}
          setInfCpl={setInfCpl}
          mostrarCobranca={mostrarCobranca}
          setMostrarCobranca={setMostrarCobranca}
          limparParametros={limparParametros}

        ></FinalizarVenda>) :
          isControleCaixaVisible ? (<ControleDeCaixa
            closeModal={() => { setIsControleCaixaVisible(false); setTelaControleDeCaixa(false); }}
            onItemPress={trataProdutos}
            setConsumidorIdentificado={setConsumidorIdentificado}
            consumidorIdentificado={consumidorIdentificado}
            nomeCupom={nomeCupom}
            documentoCupom={documentoCupom}
            setNomeCupom={setNomeCupom}
            setDocumentoCupom={setDocumentoCupom}
            consumidor={consumidor}
            setConsumidor={setConsumidor}
            precoTotal={precoTotal}
            pagamentoConcluido={pagamentoConcluido}
            setPagamentoConcluido={setPagamentoConcluido}
            pagamentos={pagamentos}
            setPagamentos={setPagamentos}
            produtos={produtos}
            setProdutos={setProdutos}
            subTotal={subTotal}
            CalcularTotais={CalcularTotais}
            acresDescFrete={acresDescFrete}
            setAcresDescFrete={setAcresDescFrete}
            totalDescontos={totalDescontos}
            totalAcrescimos={totalAcrescimos}
            acresDescFreteConcluido={acresDescFreteConcluido}
            setAcresDescFreteConcluido={setAcresDescFreteConcluido}
            setPagItem={setPagItem}
            pagItem={pagItem}
            travarAcrescimoDescFrete={travarAcrescimoDescFrete}
            tokenPedidoTechsapp={tokenPedidoTechsapp}
            setTokenPedidoTechsapp={setTokenPedidoTechsapp}
            formasDePagamento={formasDePagamento}
            idVendedorOrcamento={idVendedorOrcamento}
            idOrcamento={idOrcamento}
            setVendaPuxada={setVendaPuxada}
            setIdPedidoMkt={setIdPedidoMkt}
            idPedidoMkt={idPedidoMkt}
            focarCodigoDeBarras={focarCodigoDeBarras}
            setMensagemTela={setMensagemTela}
            sessaoCaixa={sessaoCaixa}
            setSessaoCaixa={setSessaoCaixa}
            handleCloseModal={handleCloseModal}
            confirmarFechamento={() => { setIsControleCaixaVisible(false); setTelaControleDeCaixa(false); }}
          ></ControleDeCaixa>) : (
            isModalVisibleItem ? (
              <ModalItemSelecionado
                isVisible={isModalVisibleItem}
                onClose={() => setModalVisibleItem(false)}
                onSave={updatedProduto => {
                  console.log(updatedProduto);
                  produtos[updatedProduto.index] = updatedProduto;
                  //produto = updatedProduto;
                  setRecalcular(!recalcular);
                  limparPagamento();
                }}
                onDelete={item => {
                  produtos.splice(item.index, 1);
                  setRecalcular(!recalcular);
                  limparPagamento();
                }}
                produto={selectedProduto}
              />
            ) : (
              // Caso contrário, exibe a tela de vendas
              <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                  {/* <button
              style={{
                flex: 1,
                marginRight: '10px',
                backgroundColor: '#800080',
                color: '#fff',
                padding: '15px',
                borderRadius: '5px',
                border: 'none',
                fontSize: '16px',
              }}
              onClick={()=>{setIsLerCodigo(true)}} 
            >
              <span style={{ display: 'block', fontSize: '24px' }}>📷</span>
              Ler Código
            </button>*/}

                  <div
                    style={{
                      backgroundColor: '#ffffff',
                      padding: '18px',
                      borderRadius: '16px',
                      boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
                      border: '1px solid #eeeeee',
                      width: '100%'
                    }}
                  >
                    {/* Data, terminal e operador */}
                    <div
                      style={{
                        display: 'grid',
                        width: '100%',
                        gridTemplateColumns: '2fr 1fr 1fr 1fr 1fr',
                        gap: '12px',
                        marginBottom: '12px',
                        alignItems: 'stretch',
                      }}
                    >
                      <CardResumoVendas
                        mostrarCertificado={mostrarCertificado}
                        mensagemCertificado={config?.mensagemCertificado}
                        onRenovarCertificado={async (e) => {
                          e.stopPropagation();

                          window.open(
                            'https://seucertificadodigital.com/loja/?p=u49-tech-union',
                            '_blank'
                          );

                          const options = {
                            headers: {
                              Accept: 'application/json',
                              'Content-Type': 'application/json',
                              Authorization: `Bearer ${accessToken}`,
                            },
                          };

                          try {
                            await axiosInstance.get(
                              `${api.technfe}/v1/enviarEmailRenovarCertificado/${config?.restaurante?.nome}`,
                              options
                            );
                          } catch (error) {
                            console.error(
                              'Erro ao enviar e-mail de renovação do certificado:',
                              error
                            );
                          }
                        }}
                      />
                      <CardResumo
                        icone="👤"
                        titulo="Operador"
                        valor={operador || 'Não informado'}
                        descricao=""
                        cor="#00a86b"
                        fundoIcone="#e8f8f1"
                      />


                      <CardResumo
                        icone="⌨️"
                        titulo="Terminal"
                        valor={terminal || '1'}
                        descricao=""
                        cor="#1677ff"
                        fundoIcone="#eaf3ff"
                      />
                      <CardResumo
                        icone="💵"
                        titulo="Caixa"
                        valor={sessaoCaixa?.caixaDescricao || ''}
                        descricao={
                          sessaoCaixa?.abertura
                            ? `Aberto em ${formatarDataHora(sessaoCaixa.abertura)}`
                            : ''
                        }
                        cor="#00a86b"
                        fundoIcone="#e8f8f1"
                        onClick={() => { setIsControleCaixaVisible(true); setTelaControleDeCaixa(true); }}
                      />
                      <CardResumo
                        icone="📅"
                        titulo="Data"
                        valor={getDataAtual()}
                        descricao=""
                        cor="#6c4cff"
                        fundoIcone="#f0ecff"
                      />

                    </div>
                  </div>


                </div>
                <div style={{ display: 'flex', marginBottom: '20px', gap: '10px' }}>
                  <button
                    onClick={handlePesquisarClick}
                    style={{
                      flex: 1,
                      marginRight: '10px',
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: idPedidoMkt ? 'not-allowed' : 'pointer',
                    }}

                    disabled={idPedidoMkt}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>🔍</span>
                    Pesquisar Produto
                  </button>

                  <button
                    style={{
                      flex: 1,
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                    }}
                    disabled={vendaPuxada}
                    onClick={() => {
                      setIsBuscarOrcamento(true);
                    }}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                    Buscar Orçamento
                  </button>

                  <button
                    style={{
                      flex: 1,
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                    }}
                    disabled={vendaPuxada}
                    onClick={() => {
                      setIsBuscarVenda(true);
                    }}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>📄</span>
                    Buscar Venda
                  </button>
                  <button
                    style={{
                      flex: 1,
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                    }}
                    disabled={vendaPuxada}
                    onClick={() => {
                      setMensagemTela('Aguarde processamento dos itens do Pedido...');
                      setIsBuscarDelivery(true);
                    }}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>🏍️</span>
                    Buscar Delivery
                  </button>
                  <button
                    style={{
                      flex: 1,
                      backgroundColor: '#000',
                      color: '#fff',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: vendaPuxada ? 'not-allowed' : 'pointer',
                    }}
                    disabled={vendaPuxada}
                    // disabled={true}
                    onClick={() => {
                      setIsBuscarPedidoMkt(true);
                    }}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>🛒</span>
                    MarketPlace
                  </button>
                  <button
                    style={{
                      flex: 1,
                      backgroundColor: '#90ee90',
                      color: '#000',
                      padding: '15px',
                      borderRadius: '5px',
                      border: 'none',
                      fontSize: '16px',
                      cursor: 'pointer',
                    }}

                    onClick={() => {
                      if (produtos.length > 0 && !temPrecoZeradoOuNulo(produtos)) {
                        setIsFinalizarVenda(true);
                      } else {
                        window.alert(
                          produtos.length === 0
                            ? 'Adicione produtos à compra!'
                            : 'Existem produtos com preço zerado ou inválido!'
                        );
                      }
                    }}
                  >
                    <span style={{ display: 'block', fontSize: '24px' }}>✔️</span>
                    Finalizar Venda
                  </button>
                </div>

                <div
                  style={{
                    backgroundColor: '#ffffff',
                    padding: '18px',
                    borderRadius: '16px',
                    boxShadow: '0 6px 24px rgba(0, 0, 0, 0.06)',
                    border: '1px solid #eeeeee',
                  }}
                >


                  {/* Quantidades e valores na mesma linha */}
                  <div
                    style={{
                      display: 'grid',
                      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
                      gap: '10px',
                      marginBottom: '14px',
                    }}
                  >

                    <CardResumo
                      icone="📦"
                      titulo="Valor Produtos"
                      valor={Number(totalProdutos || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                      descricao=""
                      cor="#1677ff"
                      fundoIcone="#eaf3ff"
                    />

                    <CardResumo
                      icone="📦"
                      titulo="Qtd Produtos"
                      valor={formatarQuantidade(quantidadeProdutos || 0)}
                      descricao=""
                      cor="#1677ff"
                      fundoIcone="#eaf3ff"
                    />


                    <CardResumo
                      icone="⭐"
                      titulo="Valor Serviços"
                      valor={Number(totalServicos || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                      descricao=""
                      cor="#00a86b"
                      fundoIcone="#e8f8f1"
                    />
                    <CardResumo
                      icone="🛎️"
                      titulo="Qtd Serviços"
                      valor={formatarQuantidade(quantidadeServicos || 0)}
                      descricao=""
                      cor="#00a86b"
                      fundoIcone="#e8f8f1"
                    />
                    <CardResumo
                      icone="🛍️"
                      titulo="Qtd Total"
                      valor={formatarQuantidade(quantidadeDeItens || 0)}
                      descricao=""
                      cor="#f59e0b"
                      fundoIcone="#fff4dc"
                    />

                    <CardResumo
                      icone="💰"
                      titulo="Valor Total"
                      valor={Number(totalSemFrete || 0).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                      })}
                      descricao=""
                      cor="#6c4cff"
                      fundoIcone="#f0ecff"
                      destaque
                    />


                  </div>

                  {/* Código de barras */}
                  <div
                    style={{
                      background:
                        'linear-gradient(135deg, hsl(240, 1%, 46%) 0%, #1f1f1f 100%)',
                      border: '1px solid #8b6cff',
                      borderRadius: '12px',
                      padding: '12px 16px',
                    }}
                  >


                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                      }}
                    >
                      <div
                        style={{
                          width: '100%',
                          maxWidth: '620px',
                          display: 'flex',
                          alignItems: 'stretch',
                        }}
                      >
                        <div
                          style={{
                            width: '48px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#f4f4f6',
                            border: '1px solid #d9d9d9',
                            borderRight: 'none',
                            borderRadius: '8px 0 0 8px',
                            fontSize: '20px',
                          }}
                        >
                          ▥
                        </div>

                        <input
                          ref={inputRef}
                          type="text"
                          placeholder="Digite ou leia o código de barras"
                          disabled={Boolean(idPedidoMkt)}
                          onKeyDown={handleKeyDown}
                          style={{
                            flex: 1,
                            minWidth: 0,
                            padding: '11px 14px',
                            border: '1px solid #d9d9d9',
                            borderRadius: '0 8px 8px 0',
                            fontSize: '14px',
                            textAlign: 'center',
                            outline: 'none',
                            backgroundColor: idPedidoMkt
                              ? '#f0f0f0'
                              : '#ffffff',
                          }}
                        />
                      </div>
                    </div>
                    <span
                      style={{
                        display: 'block',
                        textAlign: 'center',
                        color: '#fff',
                        fontSize: '14px',
                        marginTop: '6px',
                      }}
                    >
                      Pressione ENTER após digitar ou ler o código
                    </span>
                  </div>
                </div>

                {/* Mensagem durante processamento + Loading */}
                {isLoading && (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    marginTop: 40,
                    width: '100%'
                  }}>
                    <Spin
                      spinning={true}
                      tip={
                        <span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>
                          {mensagemTela || 'Carregando produtos...'}
                        </span>
                      }
                      size="large"
                    />

                    {/* Mensagem adicional abaixo do Spin (opcional, mais visível) */}
                    {mensagemTela && (
                      <div style={{
                        marginTop: 16,
                        fontSize: 15,
                        color: '#333',
                        fontWeight: 'bold',
                        textAlign: 'center'
                      }}>
                        {mensagemTela}
                      </div>
                    )}
                  </div>
                )}

                {/* Mensagem quando não tem produtos e não está carregando */}
                {!isLoading && mensagemTela && produtos?.length === 0 && (
                  <div style={{
                    marginTop: '10px',
                    textAlign: 'center',
                    color: '#333',
                    fontWeight: 'bold'
                  }}>
                    {mensagemTela}
                  </div>
                )}

                {isLoading ?
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 40, width: '100%' }}>
                    <Spin
                      spinning={isLoading}
                      tip={<span style={{ fontSize: 16, fontWeight: '500', color: '#333' }}>Carregando...</span>}
                      size="large"
                    />
                  </div>
                  : ''}

                {[...produtos].reverse().map((produto, index) => {
                  const originalIndex = produtos.length - 1 - index;

                  return (
                    <div
                      key={produto._uid}
                      className={`cardT ${produto.travado ? 'travado' : ''}`}
                      onClick={() => {
                        console.log(originalIndex);
                        if (!produto.travado) openModalItem({ ...produto, index: originalIndex });
                      }}
                      style={{ display: "flex", width: "100%" }}
                    >
                      {/* ESQUERDA - 60% */}
                      <div style={{ width: "60%" }}>
                        <span className="cardTextNome">{produto.nome}</span><br />
                        <span className="cardText">{`${produto.ean}`}</span><br />
                        <span className="cardText">
                          {`${formatarQuantidade(produto.quantidade)} ${produto.unidade || 'UN'} X ${produto.preco.toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} = ${(produto.quantidade * produto.preco).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} - ${parseFloat(produto.valorDesconto).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} + ${parseFloat(produto.valorAcrescimo).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })} = ${(parseFloat(produto.quantidade) * parseFloat(produto.preco)
                            - parseFloat(produto.valorDesconto) + parseFloat(produto.valorAcrescimo)
                          ).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}`}
                        </span>
                      </div>

                      {/* DIREITA - 40% */}
                      <div style={{ width: "40%", paddingLeft: "10px", borderLeft: "1px solid #ddd" }}>
                        <span className="cardText">
                          {produto.observacao || <i style={{ color: "#aaa" }}>Sem observação</i>}
                        </span>
                      </div>
                    </div>
                  );
                })}

              </div>
            )
          )}
    </div>
  );
};



const cardInfoStyle = {
  backgroundColor: '#fafafa',
  border: '1px solid #e8e8e8',
  borderRadius: '12px',
  padding: '14px 16px',
  minHeight: '74px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
};

const labelStyle = {
  color: '#777',
  fontSize: '13px',
  marginBottom: '6px',
};

const valueStyle = {
  color: '#111',
  fontSize: '17px',
  fontWeight: '700',
};

export default TelaVendas;
